export default "__VITE_ASSET__ce9d05c5__"